import { render, staticRenderFns } from "./panel-item-edit.vue?vue&type=template&id=1d44e9fe&"
import script from "./panel-item-edit.js?vue&type=script&lang=js&"
export * from "./panel-item-edit.js?vue&type=script&lang=js&"
import style0 from "./panel-item-edit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "panel-item-edit.vue"
export default component.exports